import http from '@/services'
import Service from '@/services/Service'
import { formataDataBD, converterDataDB } from '@/utils/utils'

class CompanyService extends Service {
  constructor() {
    super('COMPANY')
    this.resource = 'companies'
  }

  translateToFirebird(obj) {
    // const complemento = {
    //   IMAGEM: obj.foto,
    // }

    let objFirebird = {
      CODIGO: obj.codigo ?? 0,
      NOME: obj.nome ?? null,
      RAZAOSOCIAL: obj.razaoSocial,
      CGC: obj.cgc,
      RG: obj.rg ?? null,
      IE: obj.ie ?? null,
      PAI: obj.pai ?? null,
      MAE: obj.mae ?? null,
      EMAIL: obj.email ?? null,
      CEP: obj.cep,
      ENDERECO: obj.endereco,
      NUMERO: obj.numero,
      BAIRRO: obj.bairro,
      UF: obj.uf,
      FONE: obj.fone,
      CELULAR: obj.celular ?? null,
      NASCIMENTO: obj.dataNascimento ? formataDataBD(obj.dataNascimento) : null,
      DATAEMISSAORG: obj.dataEmissaoRG
        ? formataDataBD(obj.dataEmissaoRG)
        : null,
      ORGAOEMISSOR: obj.orgaoEmissor ?? null,
      CONJUJE: obj.conjuje ?? null,
      CODIGOCONJUJE: obj.codigoConjuje ?? null,
      cidade: obj.cidade,
      pais: obj.pais,
      tipoEmpresa: obj.tipoEmpresa ?? null,
      tipoVenda: obj.tipoVenda ?? null,
      ATIVO: obj.ativo ?? null,
      OBSO0: obj.observacao ?? null,
      OBSO4: obj.obsBalcao,
      RAMO: obj.ramoAtividade ? obj.ramoAtividade.NOME : null,
      // complemento: complemento,
      VALORCREDITO: obj.valorCredito ?? null,
      DIASATRASO: obj.diasAtraso ?? null,
      PERC_JUROS: obj.percentualJuros ?? null,
      DATAVERIFICACAOEMAIL: obj.dataVerificacaoEmail
        ? formataDataBD(obj.dataVerificacaoEmail)
        : null,
    }

    if (obj.cidade && !obj.cidade.DESCRICAO) {
      objFirebird.cidade = {
        DESCRICAO: obj.cidade.toUpperCase(),
      }
    } else {
      objFirebird.cidade = obj.cidade
    }

    return objFirebird
  }

  translateFromFirebird(payload) {
    let objeto = {
      codigo: payload.CODIGO,
      nome: payload.NOME,
      razaoSocial: payload.RAZAOSOCIAL,
      cgc: payload.CGC,
      cep: payload.CEP,
      endereco: payload.ENDERECO,
      numero: payload.NUMERO,
      bairro: payload.BAIRRO,
      uf: payload.UF,
      fone: payload.FONE,
      celular: payload.CELULAR,
      email: payload.EMAIL,
      rg: payload.RG,
      ie: payload.IE,
      pai: payload.PAI,
      mae: payload.MAE,
      conjuje: payload.CONJUJE,
      codigoConjuje: payload.CODIGOCONJUJE,
      dataNascimento: converterDataDB(payload.NASCIMENTO),
      dataEmissaoRG: converterDataDB(payload.DATAEMISSAORG),
      ativo: payload.ATIVO,
      observacao: payload.OBSO0,
      obsBalcao: payload.OBSO4,
      ramoAtividade: payload.RAMO ? { NOME: payload.RAMO } : null,
      cidade: payload.cidade,
      pais: payload.pais,
      tipoEmpresa: payload.tipo_empresa,
      tipoVenda: payload.tipo_venda,
      foto: payload.complemento ? payload.complemento.IMAGEM : null,
      vendedor: payload.vendedor ?? null,
      saldoLimiteCredito: payload.LIMITECREDITO,
      valorCredito: payload.VALORCREDITO,
      diasAtraso: payload.DIASATRASO,
      percentualJuros: payload.PERC_JUROS,
      dataCadastro: converterDataDB(payload.DATACADASTRO),
      dataAtualizacaoCadastro: converterDataDB(payload.DATAATUALIZACAOCADASTRO),
      cadastradoPor: payload.CADASTRADOPOR,
      alteradoPor: payload.ALTERADOPOR,
      dataVerificacaoEmail: converterDataDB(payload.DATAVERIFICACAOEMAIL),
      // a principio apenas para controle do componente limite de credito
      moeda: payload.MOEDA,
      bloqueado: payload.BLOQUEADO ?? null,
    }
    return objeto
  }

  async insertRemoteCompany(payload, resource) {
    http.defaults.headers = {
      Accept: 'multipart/form-data',
      'Content-Type': 'multipart/form-data',
    }
    const { data } = await http.post(resource, payload)

    return data
  }

  async quickRegister(payload) {
    const resource = `${this.resource}/quick-register`
    const { data } = await http.post(resource, payload)

    return data
  }

  async getCompany(id) {
    let requestUrl = `${this.resource}/${encodeURIComponent(id)}`
    let data = await this.getAPI(requestUrl)
    return this.translateFromFirebird(data)
  }

  async getCompanies(query = null) {
    if (query) {
      let requestUrl = `${this.resource}?`

      query = this.encodeQueryValues(query)

      if (query.codigo) {
        requestUrl += this.hasParameter(requestUrl)
          ? `&CODIGO=${query.codigo}`
          : `CODIGO=${query.codigo}`
      } else if (query.nome || query.razao) {
        let value = query.nome || query.razao
        requestUrl += this.hasParameter(requestUrl)
          ? `&NOME=${value}`
          : `NOME=${value}`
      } else if (query.cidade) {
        requestUrl += this.hasParameter(requestUrl)
          ? `&CIDADE=${query.cidade}`
          : `CIDADE=${query.cidade}`
      } else if (query.documento) {
        requestUrl += this.hasParameter(requestUrl)
          ? `&CGC=${query.documento}`
          : `CGC=${query.documento}`
      } else if (query.telefone) {
        requestUrl += this.hasParameter(requestUrl)
          ? `&FONE=${query.telefone}`
          : `FONE=${query.telefone}`
      } else if (query.contato || query.representante) {
        let value = query.contato || query.representante
        requestUrl += this.hasParameter(requestUrl)
          ? `&REPRESENTANTE=${value}`
          : `REPRESENTANTE=${value}`
      } else if (query.tipoEmpresa) {
        requestUrl += this.hasParameter(requestUrl)
          ? `&TIPO=${query.tipoEmpresa}`
          : `TIPO=${query.tipoEmpresa}`
      } else if (query.hibrido) {
        // consulta pelo codigo nome razaosocial cgc rg
        requestUrl += this.hasParameter(requestUrl)
          ? `&HIBRIDO=${query.hibrido}`
          : `HIBRIDO=${query.hibrido}`
      }

      if (query.page > 1)
        requestUrl += this.hasParameter(requestUrl)
          ? `&page=${query.page}`
          : `page=${query.page}`

      return await this.getAPI(requestUrl)
    } else {
      return Promise.reject('Ocorreu um erro')
    }
  }
}

export default new CompanyService()
